import MultiSelectorPicker from './multi-selector-picker.vue'
export type { MultiSelectorPickerProps } from './props'
export default MultiSelectorPicker